import React from 'react';

const LocationUIContext = React.createContext({});

export const LocationUIContextProvider = ({ children, value }) => {
    return <LocationUIContext.Provider value={value}>{children}</LocationUIContext.Provider>;
};

export const useLocationUIContext = () => {
    const context = React.useContext(LocationUIContext);

    if (context == null) {
        throw new Error(`'useLocationUIContext' needs to be within 'LocationUIContext'`);
    }

    return context;
};
